import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";

export class DistributorUsersQuery {
  constructor(
    private readonly dispatcher: QueryDispatcher,
    private readonly frontend,
  ) { }

  async run(): Promise<any> {
    let args = {         
    }    
    let res = await this.dispatcher.dispatch('get.distributor.users', args)    
    if (res.promise['status'] === '200') {
      this.frontend.distributor_users = res.promise['data']
    } else {
      return res.promise['data']
    }    
  }
}